import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.914"
    height="19.914"
    viewBox="0 0 19.914 19.914"
    className={className}
  >
    <g transform="translate(1.25 1.25)">
      <g>
        <path
          d="M1.161,0H16.253a1.161,1.161,0,0,1,1.161,1.161V16.253a1.161,1.161,0,0,1-1.161,1.161H1.161A1.161,1.161,0,0,1,0,16.253V1.161A1.161,1.161,0,0,1,1.161,0Z"
          fill="#ffd2d2"
          stroke="#ff1c1c"
          stroke-width="2.5"
        />
        <path
          d="M2,0H15a2,2,0,0,1,2,2V3a0,0,0,0,1,0,0H0A0,0,0,0,1,0,3V2A2,2,0,0,1,2,0Z"
          fill="#ff1c1c"
        />
        <circle
          cx="0.75"
          cy="0.75"
          r="0.75"
          transform="translate(2 0.5)"
          fill="#ffd2d2"
        />
        <circle
          cx="0.75"
          cy="0.75"
          r="0.75"
          transform="translate(4 0.5)"
          fill="#ffd2d2"
        />
        <circle
          cx="0.75"
          cy="0.75"
          r="0.75"
          transform="translate(6 0.5)"
          fill="#ffd2d2"
        />
      </g>
      <g transform="translate(4 4.7)">
        <path
          d="M12,4.5a.737.737,0,0,0-.053-.224l-1-2A.5.5,0,0,0,10.5,2h-7a.5.5,0,0,0-.447.276l-1,2A.738.738,0,0,0,2,4.5V5a1.983,1.983,0,0,0,.5,1.309V11.5A.5.5,0,0,0,3,12h8a.5.5,0,0,0,.5-.5V6.309A1.983,1.983,0,0,0,12,5ZM10,6A1,1,0,0,1,9,5h2A1,1,0,0,1,10,6ZM3,5H5A1,1,0,0,1,3,5ZM8,5A1,1,0,0,1,6,5ZM3.809,3h6.382l.5,1H3.309ZM6.5,11V9.5a.5.5,0,1,1,1,0V11Zm2,0V9.5a1.5,1.5,0,1,0-3,0V11h-2V6.929a1.932,1.932,0,0,0,2-.62,1.973,1.973,0,0,0,3,0,1.932,1.932,0,0,0,2,.62V11Z"
          transform="translate(-2 -2)"
          fill="#ff1c1c"
        />
      </g>
    </g>
  </svg>
);
